import { ADITIONAL_SERVICES } from "../constants/commonConstants";

const activeServicesByLabel = new Map(
  ADITIONAL_SERVICES.map((service) => [service.label, service])
);

export const normalizeAdditionalServices = (services = []) => {
  const normalized = [];
  const seenLabels = new Set();

  (Array.isArray(services) ? services : []).forEach((service) => {
    const config = activeServicesByLabel.get(service?.label);
    if (!config || seenLabels.has(config.label)) return;

    normalized.push({
      ...service,
      label: config.label,
      costType: config.costType,
    });
    seenLabels.add(config.label);
  });

  ADITIONAL_SERVICES
    .filter((service) => service.isIncluded)
    .forEach((service) => {
      if (seenLabels.has(service.label)) return;

      normalized.push({
        label: service.label,
        costType: service.costType,
      });
      seenLabels.add(service.label);
    });

  return normalized;
};
